<div class="pp-table-wrap">
  <ng-content select="[caption]"></ng-content>

  <p-table
    #acanPTable
    [styleClass]="tableStyleClass"
    [value]="showSkeleton ? skeletonRowIndexes : value"
    [lazy]="lazy"
    [paginator]="paginator"
    [rows]="rows"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [paginatorDropdownAppendTo]="'body'"
    [totalRecords]="totalRecords"
    [dataKey]="dataKey"
    [rowHover]="rowHover"
    [loading]="loading"
    [selection]="selection"
    [selectionMode]="selectionMode"
    [showCurrentPageReport]="showCurrentPageReport"
    [currentPageReportTemplate]="currentPageReportTemplate"
    [sortField]="sortField"
    [sortOrder]="sortOrder"
    [defaultSortOrder]="defaultSortOrder"
    [customSort]="isCustomSort"
    [tableStyle]="tableStyle"
    (onLazyLoad)="lazyLoad.emit($event)"
    (selectionChange)="onSelectionChange($event)"
    (sortFunction)="onSort($event)"
    responsiveLayout="scroll">
    <ng-template pTemplate="header">
      <tr>
        <th
          *ngIf="selectionMode"
          class="pp-center pp-table__check">
          <p-tableHeaderCheckbox *ngIf="selectionMode === 'multiple'"></p-tableHeaderCheckbox>
        </th>
        <th
          *ngFor="let col of columns"
          [pSortableColumn]="col.sortable ? col.field : ''"
          [pSortableColumnDisabled]="!col.sortable"
          [ngClass]="columnClass(col)"
          [style.width]="col.width || null">
          {{ col.header }}
          <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
        </th>
        <th *ngIf="showActionsColumn" class="pp-center pp-table__actions" [style.width]="actionsWidth || '2.5rem'"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <ng-container *ngIf="showSkeleton; else dataRow">
        <tr>
          <td *ngIf="selectionMode"><p-skeleton></p-skeleton></td>
          <td *ngFor="let col of columns"><p-skeleton></p-skeleton></td>
          <td *ngIf="showActionsColumn"><p-skeleton></p-skeleton></td>
        </tr>
      </ng-container>
      <ng-template #dataRow>
        <tr (click)="onRowClick(row, $event)">
          <td
            *ngIf="selectionMode"
            class="pp-center pp-table__check"
            (click)="$event.stopPropagation()">
            <p-tableCheckbox *ngIf="selectionMode === 'multiple'" [value]="row"></p-tableCheckbox>
            <p-tableRadioButton *ngIf="selectionMode === 'single'" [value]="row"></p-tableRadioButton>
          </td>
          <td
            *ngFor="let col of columns"
            [ngClass]="columnClass(col)"
            [style.width]="col.width || null">
            <ng-container *ngIf="cellTemplate(col) as tmpl; else plainCell">
              <ng-container
                *ngTemplateOutlet="tmpl; context: { $implicit: row, col: col }"></ng-container>
            </ng-container>
            <ng-template #plainCell>
              {{ cellValue(row, col.field) }}
            </ng-template>
          </td>
          <td *ngIf="showActionsColumn" class="pp-center pp-table__actions" (click)="$event.stopPropagation()">
            <ng-container *ngIf="actionsTemplate as actionsTmpl">
              <ng-container
                *ngTemplateOutlet="actionsTmpl; context: { $implicit: row }"></ng-container>
            </ng-container>
          </td>
        </tr>
      </ng-template>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr *ngIf="!showSkeleton">
        <td [attr.colspan]="emptyColspan">
          <ng-container *ngIf="emptyTemplate as emptyTmpl; else defaultEmpty">
            <ng-container *ngTemplateOutlet="emptyTmpl"></ng-container>
          </ng-container>
          <ng-template #defaultEmpty>
            <acan-empty-state [message]="emptyMessage"></acan-empty-state>
          </ng-template>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
